export default {
  methods: {
    //DISPATCHES
    setError(err, prevent, actionEv) {
      if (!err || !err.response || (err.response && err.response.status >= 500)) {
        err = {
          response: {
            status: "500",
            statusText: "server_error",
          },
        };
      } else {
        document.dispatchEvent(
          new CustomEvent("error-" + err.message, {
            detail: {
              preventDefault: prevent | false,
              callbackEvent: actionEv,
              data: err,
            },
          }),
        );
      }
      const errorStatus = err.response?.status || "500";
      document.dispatchEvent(
        new CustomEvent("error-" + errorStatus, {
          detail: {
            preventDefault: prevent | false,
            callbackEvent: actionEv,
            data: err.response,
          },
        }),
      );
    },
  },
};
